(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pawmore-native-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pawmore-native-offer')) {
    customElements.define(
      'pawmore-native-offer',
      class PawmoreNativeOffer extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;
          this.dataset.initialized = 'true';
          this.offerControls = Array.from(this.querySelectorAll('[data-offer-choice]'));
          this.countControls = Array.from(this.querySelectorAll('[data-pet-count-control]'));
          this.productVariants = this.parseProductVariants();
          this.tierPrices = {
            solo: this.parseTierPrices(this.dataset.soloTierPrices, this.dataset.primaryPrice),
            pair: this.parseTierPrices(
              this.dataset.pairTierPrices,
              Number.parseInt(this.dataset.primaryPrice || '0', 10) +
              Number.parseInt(this.dataset.companionPrice || '0', 10)
            )
          };
          this.soloTierTotals = this.parseTierPrices(
            this.dataset.soloTierTotals,
            this.dataset.primaryPrice
          );
          this.pairTierTotals = [1, 2, 3].reduce((tiers, count) => {
            tiers[count] = this.tierPrices.pair[count] * count;
            return tiers;
          }, {});
          this.syncTierPricesFromKaching();
          this.kachingAccessibilityRoot =
            this.closest('.pawmore-product-details--native-offer') || document.body;
          this.kachingAccessibilityObserver = new MutationObserver(() => {
            this.syncHiddenKachingAccessibility();
          });
          this.kachingAccessibilityObserver.observe(this.kachingAccessibilityRoot, {
            childList: true,
            subtree: true,
          });
          this.onChange = this.handleChange.bind(this);
          this.onVariantChange = this.handleVariantChange.bind(this);
          this.addEventListener('change', this.onChange);
          document.addEventListener('simple-variant-picker:variantChange', this.onVariantChange);
          this.syncHiddenKachingAccessibility();
          this.connectForm(0);
        }

        disconnectedCallback() {
          this.kachingAccessibilityObserver?.disconnect();
          this.atcObserver?.disconnect();
          this.removeEventListener('change', this.onChange);
          document.removeEventListener('simple-variant-picker:variantChange', this.onVariantChange);
        }

        syncHiddenKachingAccessibility() {
          const productDetails = this.kachingAccessibilityRoot;
          if (!productDetails) return;

          productDetails
            .querySelectorAll('.shop-add-to-cart-wrapper > kaching-bundle')
            .forEach((widget) => {
              widget.setAttribute('aria-hidden', 'true');
              widget.setAttribute('inert', '');
            });
        }

        connectForm(attempt) {
          const productInfo = this.closest('.shop-product-info');
          this.form = productInfo?.querySelector('product-form form');

          if (!this.form && attempt < 20) {
            window.setTimeout(() => this.connectForm(attempt + 1), 50);
            return;
          }

          this.observeAtc();
          this.updateFormItems();
        }

        observeAtc() {
          const productForm = this.form?.closest('product-form');
          if (!productForm || this.atcObserver) return;

          this.atcObserver = new MutationObserver(() => {
            const submitButton = productForm.querySelector('[type="submit"]');
            const currentPrice = submitButton?.querySelector('[data-pdp-atc-current-price]');
            if (
              !submitButton ||
              submitButton.classList.contains('loading') ||
              submitButton.classList.contains('sold-out') ||
              !currentPrice
            ) {
              return;
            }

            const expectedPrice = this.formatMoney(
              this.getTierTotalPrice(this.getOfferChoice(), this.getPetCount())
            );

            if (currentPrice.textContent.trim() !== expectedPrice) {
              this.updateButtonText(this.getPetCount(), this.getOfferChoice());
            }
          });
          this.atcObserver.observe(productForm, {
            childList: true,
            characterData: true,
            subtree: true
          });
        }

        handleChange(event) {
          if (event.target.matches('[data-pet-count-control]')) {
            this.syncCountControls(event.target);
          }

          this.updateFormItems();
        }

        handleVariantChange(event) {
          const eventVariantId = Number.parseInt(event.detail?.variant?.id || '', 10);
          const localVariantId = Number.parseInt(this.form?.querySelector('[name="id"]')?.value || '', 10);
          if (!Number.isFinite(eventVariantId) || eventVariantId !== localVariantId) return;

          window.setTimeout(() => this.updateFormItems(), 0);
        }

        parseProductVariants() {
          try {
            const variants = JSON.parse(this.dataset.productVariants || '[]');
            return Array.isArray(variants) ? variants : [];
          } catch (error) {
            return [];
          }
        }

        parseTierPrices(value, fallback) {
          const fallbackPrice = Number.parseInt(fallback || '0', 10);
          const prices = String(value || '')
            .split(',')
            .map((price) => Number.parseInt(price, 10));

          return [1, 2, 3].reduce((tiers, count, index) => {
            tiers[count] = Number.isFinite(prices[index]) && prices[index] > 0
              ? prices[index]
              : fallbackPrice;
            return tiers;
          }, {});
        }

        syncCountControls(source) {
          const count = String(source.value);

          this.countControls.forEach((control) => {
            if (control === source) return;

            if (control.tagName === 'SELECT') {
              control.value = count;
            } else {
              control.checked = control.value === count;
            }
          });
        }

        getPetCount() {
          const selectedCount =
            this.countControls.find((control) => control.tagName === 'SELECT')?.value ||
            this.countControls.find((control) => control.checked)?.value ||
            '1';
          const count = Number.parseInt(selectedCount, 10);
          return Math.min(3, Math.max(1, Number.isFinite(count) ? count : 1));
        }

        getOfferChoice() {
          return this.offerControls.find((control) => control.checked)?.value || 'solo';
        }

        getKachingDealBlockSettings() {
          const dealBlockId = this.dataset.kachingDealBlockId;
          const primaryProductId = Number.parseInt(this.dataset.primaryProductId || '', 10);

          if (!dealBlockId || !Number.isFinite(primaryProductId)) return null;

          const settingsScripts = document.querySelectorAll(
            'script.kaching-bundles-deal-block-settings'
          );

          for (const script of settingsScripts) {
            if (Number.parseInt(script.dataset.productId || '', 10) !== primaryProductId) continue;

            try {
              const settings = JSON.parse(script.textContent || '{}');
              if (settings?.id === dealBlockId) return settings;
            } catch (error) {
              continue;
            }
          }

          return null;
        }

        getDiscountedLineTotal(unitPrice, quantity, discountType, discountValue) {
          const count = Number.parseInt(quantity || '0', 10);
          const baseUnitPrice = Number.parseInt(unitPrice || '0', 10);
          const value = Number(discountValue);

          if (!Number.isFinite(count) || count < 1 || !Number.isFinite(baseUnitPrice)) {
            return null;
          }

          if (discountType === 'specific' && Number.isFinite(value)) {
            return Math.max(0, Math.round(value * 100));
          }

          let discountedUnitPrice = baseUnitPrice;

          if (discountType === 'amount' && Number.isFinite(value)) {
            discountedUnitPrice = Math.max(0, baseUnitPrice - Math.round(value * 100));
          } else if (discountType === 'percentage' && Number.isFinite(value)) {
            discountedUnitPrice = Math.max(0, Math.round(baseUnitPrice * (100 - value) / 100));
          }

          return discountedUnitPrice * count;
        }

        syncTierPricesFromKaching() {
          const settings = this.getKachingDealBlockSettings();
          if (!Array.isArray(settings?.dealBars)) return false;

          const primaryPrice = Number.parseInt(this.dataset.primaryPrice || '0', 10);
          const companionPrice = Number.parseInt(this.dataset.companionPrice || '0', 10);
          const companionProductId = Number.parseInt(this.dataset.companionProductId || '', 10);
          const companionProductGid = Number.isFinite(companionProductId)
            ? `gid://shopify/Product/${companionProductId}`
            : '';

          [1, 2, 3].forEach((petCount) => {
            const quantityBreak = settings.dealBars.find(
              (candidate) =>
                candidate?.dealBarType === 'quantity-break' &&
                Number(candidate.quantity) === petCount
            );
            const soloTotal = quantityBreak
              ? this.getDiscountedLineTotal(
                  primaryPrice,
                  petCount,
                  quantityBreak.discountType,
                  quantityBreak.discountValue
                )
              : null;

            if (Number.isFinite(soloTotal) && soloTotal > 0) {
              this.soloTierTotals[petCount] = soloTotal;
              this.tierPrices.solo[petCount] = Math.round(soloTotal / petCount);
            }

            const bundle = settings.dealBars.find((candidate) => {
              if (candidate?.dealBarType !== 'bundle' || !Array.isArray(candidate.bundleProducts)) {
                return false;
              }

              const primaryProduct = candidate.bundleProducts.find(
                (bundleProduct) => bundleProduct.productGID === 'default'
              );
              const companionProduct = candidate.bundleProducts.find(
                (bundleProduct) => bundleProduct.productGID === companionProductGid
              );

              return (
                Number(primaryProduct?.quantity) === petCount &&
                Number(companionProduct?.quantity) === petCount
              );
            });

            if (!bundle) return;

            const primaryProduct = bundle.bundleProducts.find(
              (bundleProduct) => bundleProduct.productGID === 'default'
            );
            const companionProduct = bundle.bundleProducts.find(
              (bundleProduct) => bundleProduct.productGID === companionProductGid
            );
            const primaryTotal = this.getDiscountedLineTotal(
              primaryPrice,
              primaryProduct.quantity,
              primaryProduct.discountType,
              primaryProduct.discountValue
            );
            const companionTotal = this.getDiscountedLineTotal(
              companionPrice,
              companionProduct.quantity,
              companionProduct.discountType,
              companionProduct.discountValue
            );

            if (
              Number.isFinite(primaryTotal) &&
              Number.isFinite(companionTotal) &&
              primaryTotal + companionTotal > 0
            ) {
              const pairTotal = primaryTotal + companionTotal;
              this.pairTierTotals[petCount] = pairTotal;
              this.tierPrices.pair[petCount] = Math.round(pairTotal / petCount);
            }
          });

          return true;
        }

        getKachingBundleGroupId(selection) {
          let hash = 2166136261;

          for (let index = 0; index < selection.length; index += 1) {
            hash ^= selection.charCodeAt(index);
            hash = Math.imul(hash, 16777619) >>> 0;
          }

          const characters = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
          let groupId = '';

          for (let index = 0; index < 4; index += 1) {
            groupId = characters[hash % characters.length] + groupId;
            hash = Math.floor(hash / characters.length);
          }

          return groupId;
        }

        getKachingSoloItems(petCount, primaryVariantId) {
          const settings = this.getKachingDealBlockSettings();
          const primaryProductId = Number.parseInt(this.dataset.primaryProductId || '', 10);
          const dealBar = Array.isArray(settings?.dealBars)
            ? settings.dealBars.find(
                (candidate) =>
                  candidate?.dealBarType === 'quantity-break' &&
                  Number(candidate.quantity) === petCount
              )
            : null;
          const dealId = settings?.nanoId || settings?.id;

          if (!dealBar?.id || !dealId || !Number.isFinite(primaryProductId)) return null;

          const properties = {
            deal: dealId,
            pp: primaryProductId,
            main: true,
            bid: dealBar.id
          };

          if (settings.marketId) {
            properties.market = settings.marketId;
          }
          if (settings.versionId) {
            properties.v = settings.versionId;
          }

          return [{
            id: primaryVariantId,
            quantity: petCount,
            properties: { __kaching_bundles: JSON.stringify(properties) }
          }];
        }

        getKachingPairItems(petCount, primaryVariantId, companionVariantId) {
          const settings = this.getKachingDealBlockSettings();
          const primaryProductId = Number.parseInt(this.dataset.primaryProductId || '', 10);
          const companionProductId = Number.parseInt(this.dataset.companionProductId || '', 10);

          if (!settings || !Number.isFinite(primaryProductId) || !Number.isFinite(companionProductId)) {
            return null;
          }

          const companionProductGid = `gid://shopify/Product/${companionProductId}`;
          const dealBar = Array.isArray(settings.dealBars)
            ? settings.dealBars.find((candidate) => {
                if (candidate?.dealBarType !== 'bundle' || !Array.isArray(candidate.bundleProducts)) {
                  return false;
                }

                const primaryProduct = candidate.bundleProducts.find(
                  (bundleProduct) => bundleProduct.productGID === 'default'
                );
                const companionProduct = candidate.bundleProducts.find(
                  (bundleProduct) => bundleProduct.productGID === companionProductGid
                );

                return (
                  Number(primaryProduct?.quantity) === petCount &&
                  Number(companionProduct?.quantity) === petCount
                );
              })
            : null;
          const companionBundleProduct = dealBar?.bundleProducts?.find(
            (bundleProduct) => bundleProduct.productGID === companionProductGid
          );
          const dealId = settings.nanoId || settings.id;

          if (!dealBar?.id || !companionBundleProduct?.id || !dealId) return null;

          const selection = JSON.stringify([
            [{ variantId: primaryVariantId, quantity: petCount }],
            [{
              id: companionBundleProduct.id,
              variantId: companionVariantId,
              quantity: petCount
            }],
            [],
            [],
            [],
            [],
            [],
            null,
            null,
            dealBar.id
          ]);
          const groupId = this.getKachingBundleGroupId(selection);
          const mainProperties = {
            deal: dealId,
            pp: primaryProductId,
            main: true,
            id: groupId,
            bar: dealBar.id
          };
          const companionProperties = {
            id: groupId,
            deal: dealId,
            bar: dealBar.id,
            bundleProduct: companionBundleProduct.id
          };

          if (settings.marketId) {
            mainProperties.market = settings.marketId;
          }
          if (settings.versionId) {
            mainProperties.v = settings.versionId;
            companionProperties.v = settings.versionId;
          }

          return [
            {
              id: primaryVariantId,
              quantity: petCount,
              properties: { __kaching_bundles: JSON.stringify(mainProperties) }
            },
            {
              id: companionVariantId,
              quantity: petCount,
              properties: { __kaching_bundles: JSON.stringify(companionProperties) }
            }
          ];
        }

        updateFormItems() {
          if (!this.form) return;

          const variantInput = this.form.querySelector('[name="id"]');
          const primaryVariantId = Number.parseInt(
            variantInput?.value || this.dataset.primaryVariantId || '',
            10
          );

          if (!Number.isFinite(primaryVariantId)) return;

          const primaryVariant = this.productVariants.find(
            (variant) => Number.parseInt(variant.id, 10) === primaryVariantId
          );
          if (primaryVariant?.price != null) {
            this.dataset.primaryPrice = String(primaryVariant.price);
          }

          this.syncTierPricesFromKaching();

          const petCount = this.getPetCount();
          const offerChoice = this.getOfferChoice();
          const items =
            this.getKachingSoloItems(petCount, primaryVariantId) ||
            [{ id: primaryVariantId, quantity: petCount }];

          if (offerChoice === 'pair' && this.dataset.companionAvailable === 'true') {
            const companionVariantId = Number.parseInt(this.dataset.companionVariantId || '', 10);

            if (Number.isFinite(companionVariantId)) {
              const kachingItems = this.getKachingPairItems(
                petCount,
                primaryVariantId,
                companionVariantId
              );

              if (kachingItems) {
                items.splice(0, items.length, ...kachingItems);
              } else {
                items.push({ id: companionVariantId, quantity: petCount });
              }
            }
          }

          this.form.dataset.pawmoreNativeOfferItems = JSON.stringify(items);
          this.form.dataset.pawmoreNativeOfferSelection = `${offerChoice}:${petCount}`;
          this.updateOfferPrices(petCount);
          this.updateProductSummary(petCount, offerChoice);
          this.updateButtonText(petCount, offerChoice);

          const status = this.querySelector('[data-native-offer-status]');
          if (status) {
            const primaryTitle = this.dataset.primaryTitle || 'primary product';
            const companionTitle = this.dataset.companionTitle || 'companion product';
            const selectedTotal = this.getTierTotalPrice(offerChoice, petCount);
            status.textContent =
              offerChoice === 'pair'
                ? `${petCount} × ${primaryTitle} and ${petCount} × ${companionTitle} selected, ${this.formatMoney(selectedTotal)} total`
                : `${petCount} × ${primaryTitle} selected, ${this.formatMoney(selectedTotal)} total`;
          }
        }

        getTierUnitPrice(offerChoice, petCount) {
          const tierPrice = this.tierPrices?.[offerChoice]?.[petCount];
          if (Number.isFinite(tierPrice) && tierPrice > 0) return tierPrice;

          const primaryPrice = Number.parseInt(this.dataset.primaryPrice || '0', 10);
          const companionPrice = Number.parseInt(this.dataset.companionPrice || '0', 10);
          return offerChoice === 'pair' && this.dataset.companionAvailable === 'true'
            ? primaryPrice + (Number.isFinite(companionPrice) ? companionPrice : 0)
            : primaryPrice;
        }

        getTierTotalPrice(offerChoice, petCount) {
          const tierTotal = offerChoice === 'pair'
            ? this.pairTierTotals?.[petCount]
            : this.soloTierTotals?.[petCount];
          if (Number.isFinite(tierTotal) && tierTotal > 0) {
            return tierTotal;
          }

          return this.getTierUnitPrice(offerChoice, petCount) * petCount;
        }

        updateOfferPrices(petCount) {
          ['solo', 'pair'].forEach((offerChoice) => {
            const price = this.querySelector(`[data-native-offer-price="${offerChoice}"]`);
            const comparePrice = this.querySelector(
              `[data-native-offer-compare-price="${offerChoice}"]`
            );
            const unitPrice = this.getTierUnitPrice(offerChoice, petCount);
            const referencePrice = Number.parseInt(
              offerChoice === 'pair'
                ? this.dataset.pairReferencePrice || '0'
                : this.dataset.soloReferencePrice || '0',
              10
            );

            if (price) price.textContent = `${this.formatMoney(unitPrice)}/pet`;
            if (!comparePrice) return;

            const hasDiscount = Number.isFinite(referencePrice) && referencePrice > unitPrice;
            comparePrice.hidden = !hasDiscount;
            if (hasDiscount) {
              const formattedReference = this.formatCompareMoney(referencePrice);
              comparePrice.textContent = formattedReference;
              comparePrice.setAttribute('aria-label', `Regular price ${formattedReference} per pet`);
            }
          });
        }

        updateProductSummary(petCount, offerChoice) {
          const summary = this.closest('.shop-product-info')?.querySelector('[data-native-offer-summary]');
          if (!summary) return;

          const currentPrice = summary.querySelector('[data-native-offer-summary-current]');
          const comparePrice = summary.querySelector('[data-native-offer-summary-compare]');
          const discountBadge = summary.querySelector('[data-native-offer-summary-discount]');
          const screenReaderPrice = summary.querySelector('[data-native-offer-summary-sr]');
          const unitPrice = this.getTierUnitPrice(offerChoice, petCount);
          const rawReferencePrice = Number.parseInt(
            offerChoice === 'pair'
              ? this.dataset.pairReferencePrice || '0'
              : this.dataset.soloReferencePrice || '0',
            10
          );
          const summaryReferencePrice = Number.parseInt(
            offerChoice === 'pair'
              ? this.dataset.pairSummaryReferencePrice || '0'
              : this.dataset.soloSummaryReferencePrice || '0',
            10
          );
          const totalPrice = this.getTierTotalPrice(offerChoice, petCount);
          const rawReferenceTotal = rawReferencePrice * petCount;
          const summaryReferenceTotal = summaryReferencePrice * petCount;
          const hasDiscount =
            Number.isFinite(rawReferenceTotal) && rawReferenceTotal > totalPrice;
          const formattedUnitPrice = this.formatMoney(unitPrice);

          if (currentPrice) currentPrice.textContent = formattedUnitPrice;
          if (screenReaderPrice) screenReaderPrice.textContent = `Current price ${formattedUnitPrice} per pet`;

          if (comparePrice) {
            comparePrice.hidden = !hasDiscount;
            if (hasDiscount) {
              const referencePrice = Number.isFinite(summaryReferenceTotal) && summaryReferenceTotal > 0
                ? summaryReferenceTotal
                : rawReferenceTotal;
              const formattedReference = this.formatRoundedCompareMoney(referencePrice);
              comparePrice.textContent = formattedReference;
              comparePrice.setAttribute('aria-label', `Regular price ${formattedReference} total`);
            }
          }

          if (discountBadge) {
            discountBadge.hidden = !hasDiscount;
            if (hasDiscount) {
              const discountPercentage = Math.floor(
                ((rawReferenceTotal - totalPrice) * 100) / rawReferenceTotal
              );
              discountBadge.textContent = `${discountPercentage}% OFF`;
            }
          }
        }

        updateButtonText(petCount, offerChoice) {
          const submitButton = this.form.closest('product-form')?.querySelector('[type="submit"]');
          const buttonText = submitButton?.querySelector('.button-text');
          const currentPrice = submitButton?.querySelector('[data-pdp-atc-current-price]');
          const comparePrice = submitButton?.querySelector('[data-pdp-atc-compare-price]');
          if (!submitButton || !buttonText || submitButton.classList.contains('sold-out')) return;

          const totalPrice = this.getTierTotalPrice(offerChoice, petCount);
          if (!currentPrice) return;

          const referenceUnitPrice = Number.parseInt(
            offerChoice === 'pair'
              ? this.dataset.pairReferencePrice || '0'
              : this.dataset.soloReferencePrice || '0',
            10
          );
          const referenceTotal = referenceUnitPrice * petCount;

          currentPrice.textContent = this.formatMoney(totalPrice);
          if (!comparePrice) return;

          const hasComparePrice = Number.isFinite(referenceTotal) && referenceTotal > totalPrice;
          comparePrice.hidden = !hasComparePrice;
          if (hasComparePrice) comparePrice.textContent = this.formatCompareMoney(referenceTotal);
        }

        formatCompareMoney(cents) {
          return this.formatMoney(cents);
        }

        formatRoundedCompareMoney(cents) {
          const roundedCents = Math.ceil(cents / 100) * 100;
          return this.formatMoney(roundedCents).replace(/([.,])00(?=\D*$)/, '');
        }

        formatMoney(cents) {
          if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
            const formatted = window.Shopify.formatMoney(cents, this.dataset.moneyFormat);
            const value = document.createElement('span');
            value.innerHTML = formatted;
            return value.textContent.trim();
          }

          const currency = window.Shopify?.currency?.active || 'GBP';
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency
          }).format(cents / 100);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pawmore-pdp-details-accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pawmore-pdp-details-accordion')) {
    customElements.define(
      'pawmore-pdp-details-accordion',
      class PawmorePdpDetailsAccordion extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;
          this.dataset.initialized = 'true';
          this.triggers = Array.from(this.querySelectorAll('.pawmore-pdp-details-accordion__trigger'));
          this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.duration = 400;
          this.throttleDuration = 250;
          this.lastInteraction = 0;
          this.animationTimers = new WeakMap();
          this.animatedProperties = [
            'height',
            'paddingTop',
            'paddingRight',
            'paddingBottom',
            'paddingLeft',
            'marginTop',
            'marginRight',
            'marginBottom',
            'marginLeft'
          ];
          this.onClick = this.handleClick.bind(this);
          this.addEventListener('click', this.onClick);

          this.triggers.forEach((trigger) => {
            const panel = this.getPanel(trigger);
            if (panel) panel.dataset.state = trigger.getAttribute('aria-expanded') === 'true' ? 'open' : 'closed';
          });
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
        }

        handleClick(event) {
          const trigger = event.target.closest('.pawmore-pdp-details-accordion__trigger');
          if (!trigger || !this.contains(trigger)) return;

          const now = Date.now();
          if (now - this.lastInteraction < this.throttleDuration) return;
          this.lastInteraction = now;

          const panel = this.getPanel(trigger);
          const state = panel?.dataset.state;

          if (state === 'open' || state === 'opening') {
            this.close(trigger);
          } else {
            this.triggers.forEach((otherTrigger) => {
              if (otherTrigger !== trigger) this.close(otherTrigger);
            });
            this.open(trigger);
          }
        }

        getPanel(trigger) {
          const panelId = trigger.getAttribute('aria-controls');
          return panelId ? this.querySelector(`#${CSS.escape(panelId)}`) : null;
        }

        cancelAnimation(panel) {
          const timer = this.animationTimers.get(panel);
          if (!timer) return;

          window.clearTimeout(timer);
          this.animationTimers.delete(panel);
        }

        clearAnimationStyles(panel) {
          panel.style.removeProperty('display');
          panel.style.removeProperty('height');
          panel.style.removeProperty('overflow');
          panel.style.removeProperty('transition-property');
          panel.style.removeProperty('transition-duration');
          panel.style.removeProperty('transition-timing-function');

          this.animatedProperties.slice(1).forEach((property) => {
            panel.style[property] = '';
          });
        }

        readBox(panel) {
          const styles = window.getComputedStyle(panel);

          return {
            height: `${panel.getBoundingClientRect().height}px`,
            paddingTop: styles.paddingTop,
            paddingRight: styles.paddingRight,
            paddingBottom: styles.paddingBottom,
            paddingLeft: styles.paddingLeft,
            marginTop: styles.marginTop,
            marginRight: styles.marginRight,
            marginBottom: styles.marginBottom,
            marginLeft: styles.marginLeft
          };
        }

        setBox(panel, box) {
          this.animatedProperties.forEach((property) => {
            panel.style[property] = box[property];
          });
        }

        zeroBox(panel) {
          panel.style.height = '0px';
          panel.style.paddingTop = '0px';
          panel.style.paddingBottom = '0px';
          panel.style.marginTop = '0px';
          panel.style.marginBottom = '0px';
        }

        prepareTransition(panel) {
          panel.style.overflow = 'hidden';
          panel.style.transitionProperty = 'height, margin, padding';
          panel.style.transitionDuration = `${this.duration}ms`;
          panel.style.transitionTimingFunction = 'ease';
        }

        finishAnimation(panel, state) {
          const timer = window.setTimeout(() => {
            if (state === 'closed') panel.hidden = true;
            this.clearAnimationStyles(panel);
            panel.dataset.state = state;
            this.animationTimers.delete(panel);
          }, this.duration);

          this.animationTimers.set(panel, timer);
        }

        open(trigger) {
          const panel = this.getPanel(trigger);
          const state = panel?.dataset.state;
          if (!panel || state === 'open' || state === 'opening') return;

          trigger.setAttribute('aria-expanded', 'true');
          panel.setAttribute('aria-hidden', 'false');

          if (this.prefersReducedMotion) {
            this.cancelAnimation(panel);
            panel.hidden = false;
            panel.dataset.open = 'true';
            this.clearAnimationStyles(panel);
            panel.dataset.state = 'open';
            return;
          }

          const startBox = panel.hidden ? null : this.readBox(panel);
          this.cancelAnimation(panel);
          panel.hidden = false;
          panel.dataset.open = 'true';
          panel.style.display = 'block';
          this.clearAnimationStyles(panel);
          panel.style.display = 'block';
          const endBox = this.readBox(panel);

          panel.style.transitionProperty = 'none';
          panel.style.overflow = 'hidden';
          if (startBox) {
            this.setBox(panel, startBox);
          } else {
            this.zeroBox(panel);
          }
          panel.offsetHeight;

          panel.dataset.state = 'opening';
          this.prepareTransition(panel);
          this.setBox(panel, endBox);
          this.finishAnimation(panel, 'open');
        }

        close(trigger) {
          const panel = this.getPanel(trigger);
          const state = panel?.dataset.state;
          if (!panel || state === 'closed' || state === 'closing') return;

          trigger.setAttribute('aria-expanded', 'false');
          panel.setAttribute('aria-hidden', 'true');

          if (this.prefersReducedMotion) {
            this.cancelAnimation(panel);
            panel.hidden = true;
            delete panel.dataset.open;
            this.clearAnimationStyles(panel);
            panel.dataset.state = 'closed';
            return;
          }

          const startBox = this.readBox(panel);
          this.cancelAnimation(panel);
          panel.style.transitionProperty = 'none';
          panel.style.overflow = 'hidden';
          this.setBox(panel, startBox);
          panel.offsetHeight;

          delete panel.dataset.open;
          panel.dataset.state = 'closing';
          this.prepareTransition(panel);
          this.zeroBox(panel);
          this.finishAnimation(panel, 'closed');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pawmore-pdp-jump-links"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-pawmore-jump-target]');
    if (!link) return;

    const selector = link.dataset.pawmoreJumpTarget;
    if (!selector || !selector.startsWith('#')) return;

    const target =
      document.querySelector(selector) ||
      (selector === '#pawmore-product-faq' ? document.querySelector('.pawmore-product-faq') : null);
    if (!target) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    target.style.scrollMarginTop = '100px';
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pawmore-visit-localization"] && !Shopify.designMode) return;
  try {
    (() => {
    const autoForm = document.getElementById('PawmoreVisitLocalization');
    if (!autoForm) return;

    const countryInput = autoForm.elements.country_code;
    const returnInput = autoForm.elements.return_to;
    const countries = JSON.parse(countryInput.dataset.countries);
    const currentCountry = countryInput.value;
    const storageKey = 'pawmore-region-visit-v1';
    const visitDuration = 30 * 60 * 1000;
    let request;
    let generation = 0;
    let lastTouch = 0;

    function readVisit() {
      try {
        return JSON.parse(sessionStorage.getItem(storageKey));
      } catch {
        return null;
      }
    }

    function saveVisit(visit) {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify(visit));
        return true;
      } catch {
        return false;
      }
    }

    function returnPath() {
      const url = new URL(window.location.href);
      url.searchParams.delete('country');
      return url.pathname + url.search + url.hash;
    }

    function flagFor(country) {
      return /^[A-Z]{2}$/.test(country)
        ? String.fromCodePoint(...Array.from(country, (letter) => 127397 + letter.charCodeAt(0)))
        : '🌐';
    }

    function bindSelectors() {
      document.querySelectorAll('[data-pawmore-region-form]').forEach((form) => {
        if (form.dataset.regionBound) return;
        form.dataset.regionBound = 'true';
        const select = form.elements.country_code;
        const flag = form.querySelector('[data-region-flag]');
        const updateFlag = () => { if (flag) flag.textContent = flagFor(select.value); };
        updateFlag();
        form.addEventListener('submit', () => {
          generation += 1;
          request?.abort();
          saveVisit({ lastActivity: Date.now(), checked: true });
          form.elements.return_to.value = returnPath();
        });
        select.addEventListener('change', () => {
          updateFlag();
          form.requestSubmit();
        });
      });
    }

    async function detectCountry() {
      const ownGeneration = ++generation;
      request?.abort();
      const controller = new AbortController();
      request = controller;
      const timer = setTimeout(() => controller.abort(), 4000);
      try {
        const endpoint = new URL('browsing_context_suggestions.json', window.location.origin + window.Shopify.routes.root);
        endpoint.searchParams.set('country[enabled]', 'true');
        const response = await fetch(endpoint, { signal: controller.signal, credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) return;
        const result = await response.json();
        if (ownGeneration !== generation) return;
        const country = result.detected_values?.country?.handle;
        if (!countries.includes(country) || country === currentCountry) return;
        if (!saveVisit({ lastActivity: Date.now(), checked: true })) return;
        countryInput.value = country;
        returnInput.value = returnPath();
        autoForm.requestSubmit();
      } catch {
      } finally {
        clearTimeout(timer);
      }
    }

    function checkVisit() {
      if (countryInput.dataset.designMode === 'true' || document.visibilityState === 'hidden') return;
      const now = Date.now();
      const visit = readVisit();
      const active = visit?.checked === true && Number.isFinite(visit.lastActivity)
        && now >= visit.lastActivity && now - visit.lastActivity < visitDuration;
      if (active) {
        if (now - lastTouch > 10000) {
          saveVisit({ ...visit, lastActivity: now });
          lastTouch = now;
        }
        return;
      }
      if (!saveVisit({ lastActivity: now, checked: true })) return;
      lastTouch = now;
      detectCountry();
    }

    bindSelectors();
    checkVisit();
    window.addEventListener('pageshow', checkVisit);
    document.addEventListener('visibilitychange', checkVisit);
    document.addEventListener('shopify:section:load', bindSelectors);
    ['pointerdown', 'keydown', 'scroll'].forEach((event) => {
      document.addEventListener(event, checkVisit, { passive: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
